// extracted by mini-css-extract-plugin
module.exports = {"top":"title_top__1PNtg","topText":"title_topText__1ujOl"};